"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translateTaggingQuestion = exports.translateTaggingMetadata = exports.translateRangeChoices = exports.translateQuestions = exports.translateQuestionText = exports.translateQuestionObjectData = exports.translateCommonQuestionFields = exports.transformDefaultMetadata = exports.isBudgetQuestion = exports.hasPlanFlow = exports.hasHandsetFlow = exports.hasBroadbandFlow = exports.getQuestionProductType = exports.getProgressPercentage = exports.filterBrandQuestionChoices = exports.createStateMetadata = void 0;
var _constants = require("./constants");
var _services = require("../services");
var _useQuestionnaireNavigation = require("../hooks/questionnaire/useQuestionnaireNavigation");
var _logger = require("../services/logger");
let market;
const isBudgetQuestion = question => {
  return _constants.BUDGET_QUESTION_IDS.includes(question === null || question === void 0 ? void 0 : question.id);
};
exports.isBudgetQuestion = isBudgetQuestion;
const createStateMetadata = (metadata, categoryPriceTypes) => {
  _logger.Logger.info({
    segments: [_logger.Logger.LOGGER_SEGMENTS.UTILS]
  })('-- metadata', metadata);
  const stateMetadata = {
    recommendationCategories: []
  };
  Object.entries(metadata).forEach(_ref => {
    var _categoryPriceTypes$f;
    let [key, value] = _ref;
    if (key === 'flags') return;
    if (key === 'recommendationCategories') {
      // this was implemented to support the fixedRecommendations
      stateMetadata.recommendationCategories = [...stateMetadata.recommendationCategories, ...metadata.recommendationCategories];
      return;
    }
    const priceType = (_categoryPriceTypes$f = categoryPriceTypes.find(category => {
      return category.category === key;
    })) === null || _categoryPriceTypes$f === void 0 ? void 0 : _categoryPriceTypes$f.priceType;
    stateMetadata.recommendationCategories.push({
      category: key,
      priceType,
      ...value
    });
  });
  _logger.Logger.info({
    segments: [_logger.Logger.LOGGER_SEGMENTS.UTILS]
  })('-- stateMetadata', stateMetadata);
  return stateMetadata;
};
exports.createStateMetadata = createStateMetadata;
const filterBrandQuestionChoices = (questions, brandNameList) => {
  const brandQuestion = questions.find(question => question.id === _constants.QUESTION_ID.BRANDS);
  if (brandQuestion) {
    brandQuestion.choices = brandQuestion.choices.filter(choice => choice.catalogName ? brandNameList.includes(choice.catalogName.toLowerCase()) : true);
  }
};
exports.filterBrandQuestionChoices = filterBrandQuestionChoices;
const transformDefaultMetadata = defaultMetadata => {
  var _defaultMetadata$reco;
  const metadata = {};
  defaultMetadata === null || defaultMetadata === void 0 ? void 0 : (_defaultMetadata$reco = defaultMetadata.recommendationCategories) === null || _defaultMetadata$reco === void 0 ? void 0 : _defaultMetadata$reco.forEach(recommendationCategory => {
    Object.keys(recommendationCategory).filter(characteristic => !['category', 'priceType'].includes(characteristic)).forEach(characteristic => {
      var _defaultMetadata$reco2;
      metadata[recommendationCategory.category] = {
        ...metadata[recommendationCategory.category],
        [characteristic]: (_defaultMetadata$reco2 = defaultMetadata.recommendationCategories) === null || _defaultMetadata$reco2 === void 0 ? void 0 : _defaultMetadata$reco2.find(_ref2 => {
          let {
            category
          } = _ref2;
          return category === (recommendationCategory === null || recommendationCategory === void 0 ? void 0 : recommendationCategory.category);
        })[characteristic]
      };
    });
  });
  return metadata;
};
exports.transformDefaultMetadata = transformDefaultMetadata;
const translateQuestionObjectData = (questionObjectData, market) => {
  return questionObjectData ? _services.Services.locale.localeString(`Questions.${market}.${questionObjectData}`, {
    defaultValue: questionObjectData,
    skipInterpolation: true
  }) : '';
};
exports.translateQuestionObjectData = translateQuestionObjectData;
const translateQuestionText = (questionText, market) => {
  if (typeof questionText === 'object') {
    return {
      single: _services.Services.locale.localeString(`Questions.${market}.${questionText.single}`, {
        defaultValue: questionText.single,
        skipInterpolation: true
      }),
      multi: _services.Services.locale.localeString(`Questions.${market}.${questionText.multi}`, {
        defaultValue: questionText.multi,
        skipInterpolation: true
      })
    };
  }
  return translateQuestionObjectData(questionText, market);
};
exports.translateQuestionText = translateQuestionText;
const translateCommonQuestionFields = (question, market) => {
  return {
    ...question,
    title: translateQuestionObjectData(question.title, market),
    subtitle: translateQuestionText(question.subtitle, market),
    topTitle: translateQuestionObjectData(question.topTitle, market),
    stepTitle: translateQuestionObjectData(question.stepTitle, market),
    shortStepTitle: translateQuestionObjectData(question.shortStepTitle, market),
    summary: translateQuestionText(question.summary, market),
    actionBtnText: translateQuestionObjectData(question.actionBtnText, market),
    messageText: translateQuestionObjectData(question.messageText, market),
    messageTitle: translateQuestionObjectData(question.messageTitle, market)
  };
};
exports.translateCommonQuestionFields = translateCommonQuestionFields;
const translateRangeChoices = (rangeChoices, market) => {
  var _rangeChoices$labels;
  return {
    ...rangeChoices,
    minLabel: translateQuestionObjectData(rangeChoices.minLabel, market),
    maxLabel: translateQuestionObjectData(rangeChoices.maxLabel, market),
    labels: (_rangeChoices$labels = rangeChoices.labels) === null || _rangeChoices$labels === void 0 ? void 0 : _rangeChoices$labels.map(label => ({
      ...label,
      label: translateQuestionObjectData(label.label, market)
    }))
  };
};
exports.translateRangeChoices = translateRangeChoices;
const translateTaggingMetadata = data => {
  return Object.keys(data).reduce((acc, key) => {
    const keyData = `Questions.${market}.${key.trim()}`;
    const translatedKey = _services.Services.locale.localeString(keyData, {
      defaultValue: key.trim(),
      skipInterpolation: true
    });
    acc[translatedKey] = data[key];
    return acc;
  }, {});
};
exports.translateTaggingMetadata = translateTaggingMetadata;
const translateTaggingQuestion = question => {
  var _question$taggingMeta, _question$taggingMeta3, _question$taggingMeta5, _question$taggingMeta6;
  const questionWithTaggingTranslation = {
    ...question
  };
  if (question !== null && question !== void 0 && (_question$taggingMeta = question.taggingMetadata) !== null && _question$taggingMeta !== void 0 && _question$taggingMeta.tagTitlesMapping) {
    var _question$taggingMeta2;
    const newTagTitlesMapping = translateTaggingMetadata(question === null || question === void 0 ? void 0 : (_question$taggingMeta2 = question.taggingMetadata) === null || _question$taggingMeta2 === void 0 ? void 0 : _question$taggingMeta2.tagTitlesMapping);
    questionWithTaggingTranslation.taggingMetadata.tagTitlesMapping = newTagTitlesMapping;
  }
  if (question !== null && question !== void 0 && (_question$taggingMeta3 = question.taggingMetadata) !== null && _question$taggingMeta3 !== void 0 && _question$taggingMeta3.tagAnswerMapping) {
    var _question$taggingMeta4;
    const newTagAnswerMapping = translateTaggingMetadata(question === null || question === void 0 ? void 0 : (_question$taggingMeta4 = question.taggingMetadata) === null || _question$taggingMeta4 === void 0 ? void 0 : _question$taggingMeta4.tagAnswerMapping);
    questionWithTaggingTranslation.taggingMetadata.tagAnswerMapping = newTagAnswerMapping;
  }
  if (question !== null && question !== void 0 && (_question$taggingMeta5 = question.taggingMetadata) !== null && _question$taggingMeta5 !== void 0 && _question$taggingMeta5.journeyName && typeof (question === null || question === void 0 ? void 0 : (_question$taggingMeta6 = question.taggingMetadata) === null || _question$taggingMeta6 === void 0 ? void 0 : _question$taggingMeta6.journeyName) === 'object') {
    var _question$taggingMeta7;
    const newJourneyName = translateTaggingMetadata(question === null || question === void 0 ? void 0 : (_question$taggingMeta7 = question.taggingMetadata) === null || _question$taggingMeta7 === void 0 ? void 0 : _question$taggingMeta7.journeyName);
    questionWithTaggingTranslation.taggingMetadata.journeyName = newJourneyName;
  }
  return questionWithTaggingTranslation;
};
exports.translateTaggingQuestion = translateTaggingQuestion;
const translateQuestions = (questions, selectedMarket) => {
  market = _constants.MARKETS_MAP[selectedMarket];
  const translatedQuestions = questions.map(nonTranslatedQuestion => {
    const question = translateCommonQuestionFields(nonTranslatedQuestion, market);
    const questionWithTaggingTranslation = translateTaggingQuestion(question);
    switch (question.type) {
      case _constants.QUESTION_TYPE.IMAGE:
      case _constants.QUESTION_TYPE.CHOICES:
        {
          const translatedChoices = question.choices.map(choice => ({
            ...choice,
            text: translateQuestionObjectData(choice.text, market),
            summary: translateQuestionText(choice.summary, market),
            summaryText: translateQuestionObjectData(choice.summaryText, market)
          }));
          return {
            ...questionWithTaggingTranslation,
            choices: translatedChoices
          };
        }
      case _constants.QUESTION_TYPE.RANGE:
        {
          const translatedRangeChoices = translateRangeChoices(question.rangeChoices, market);
          return {
            ...questionWithTaggingTranslation,
            rangeTitle: translateQuestionObjectData(question.rangeTitle, market),
            rangeSubTitle: translateQuestionObjectData(question.rangeSubTitle, market),
            rangeChoices: translatedRangeChoices
          };
        }
      case _constants.QUESTION_TYPE.MULTI:
        {
          const translatedMulti = question.multi.map(rangeSegment => {
            const translatedRangeChoices = translateRangeChoices(rangeSegment.rangeChoices, market);
            return {
              ...rangeSegment,
              rangeChoices: translatedRangeChoices,
              rangeTitle: translateQuestionObjectData(rangeSegment.rangeTitle, market)
            };
          });
          return {
            ...questionWithTaggingTranslation,
            multi: translatedMulti
          };
        }
      case _constants.QUESTION_TYPE.SEARCH:
        return {
          ...questionWithTaggingTranslation
        };
      default:
        return questionWithTaggingTranslation;
    }
  });
  return translatedQuestions;
};
exports.translateQuestions = translateQuestions;
const hasHandsetFlow = questions => {
  return questions === null || questions === void 0 ? void 0 : questions.some(question => {
    var _question$choices;
    return question === null || question === void 0 ? void 0 : (_question$choices = question.choices) === null || _question$choices === void 0 ? void 0 : _question$choices.some(choice => {
      var _choice$enable;
      return choice === null || choice === void 0 ? void 0 : (_choice$enable = choice.enable) === null || _choice$enable === void 0 ? void 0 : _choice$enable.includes('phone');
    });
  });
};
exports.hasHandsetFlow = hasHandsetFlow;
const hasBroadbandFlow = questions => {
  return questions === null || questions === void 0 ? void 0 : questions.some(question => {
    var _question$choices2;
    return question === null || question === void 0 ? void 0 : (_question$choices2 = question.choices) === null || _question$choices2 === void 0 ? void 0 : _question$choices2.some(choice => {
      var _choice$enable2, _choice$characteristi, _choice$characteristi2, _choice$characteristi3;
      return (choice === null || choice === void 0 ? void 0 : (_choice$enable2 = choice.enable) === null || _choice$enable2 === void 0 ? void 0 : _choice$enable2.includes('broadband')) || (choice === null || choice === void 0 ? void 0 : (_choice$characteristi = choice.characteristics) === null || _choice$characteristi === void 0 ? void 0 : (_choice$characteristi2 = _choice$characteristi[0]) === null || _choice$characteristi2 === void 0 ? void 0 : (_choice$characteristi3 = _choice$characteristi2.category) === null || _choice$characteristi3 === void 0 ? void 0 : _choice$characteristi3.includes('broadband'));
    });
  });
};
exports.hasBroadbandFlow = hasBroadbandFlow;
const hasPlanFlow = questions => {
  return questions === null || questions === void 0 ? void 0 : questions.some(question => {
    var _question$choices3;
    return question === null || question === void 0 ? void 0 : (_question$choices3 = question.choices) === null || _question$choices3 === void 0 ? void 0 : _question$choices3.some(choice => {
      var _choice$enable3;
      return choice === null || choice === void 0 ? void 0 : (_choice$enable3 = choice.enable) === null || _choice$enable3 === void 0 ? void 0 : _choice$enable3.includes('plan');
    });
  });
};
exports.hasPlanFlow = hasPlanFlow;
const getProgressPercentage = _ref3 => {
  let {
    questions,
    currentQuestionIndex,
    flags = {},
    isQuestionChanged
  } = _ref3;
  // set default percentage as first choice
  if (isQuestionChanged) {
    var _currentQuestion$choi, _currentQuestion$choi2, _currentQuestion$choi3;
    const currentQuestion = questions[currentQuestionIndex];
    currentQuestion === null || currentQuestion === void 0 ? void 0 : (_currentQuestion$choi = currentQuestion.choices) === null || _currentQuestion$choi === void 0 ? void 0 : (_currentQuestion$choi2 = _currentQuestion$choi[0]) === null || _currentQuestion$choi2 === void 0 ? void 0 : (_currentQuestion$choi3 = _currentQuestion$choi2.enable) === null || _currentQuestion$choi3 === void 0 ? void 0 : _currentQuestion$choi3.forEach(enableFlag => flags[enableFlag] = true);
  }
  const flagsNames = Object.keys(flags);

  // check in case if all the questions is unique `if` flag
  const ifs = questions.map(q => q.if).filter(q => !!q);
  const uniqueIfs = [...new Set(ifs)].filter(q => !!q);
  const isUniqueFlow = ifs.length <= uniqueIfs.length;
  const questionsList = isUniqueFlow ? questions : [];
  if (!isUniqueFlow) {
    questions.forEach(q => {
      if (!q.if || flagsNames.includes(q.if)) questionsList.push(q);
    });
  }

  // find new index in the new questions flow
  const currentQuestion = questions[currentQuestionIndex];
  const newIndex = questionsList.findIndex(q => JSON.stringify(currentQuestion) === JSON.stringify(q));
  // if no other questions
  const nextQuestion = (0, _useQuestionnaireNavigation.getNextQuestionIndex)(questionsList, newIndex, flags);
  if (nextQuestion === -1) return 100;
  let percentage = Math.round((newIndex + 1) / questionsList.length * 100);
  // new index not found
  if (newIndex === -1) percentage = 100;
  return percentage;
};
exports.getProgressPercentage = getProgressPercentage;
const getQuestionProductType = function () {
  var _question$rangeCatego;
  let question = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  switch (true) {
    case question.type === _constants.QUESTION_TYPE.RANGE:
      return _constants.PRODUCT_TYPES[question === null || question === void 0 ? void 0 : (_question$rangeCatego = question.rangeCategory) === null || _question$rangeCatego === void 0 ? void 0 : _question$rangeCatego.toUpperCase()];
    case question.type === _constants.QUESTION_TYPE.MULTI:
      return question.multi.map(subQuestion => getQuestionProductType(subQuestion));
    default:
      return null;
  }
};
exports.getQuestionProductType = getQuestionProductType;